import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Download icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Download } from '@sravni/design-system-icons'
 *
 * <Download />
 * ```
 */
var Download = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Download", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.429 12.143V15A1.429 1.429 0 0 1 15 16.428H5A1.429 1.429 0 0 1 3.571 15v-2.857M6.429 8.571 10 12.143l3.571-3.572M10 12.143V3.57", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Download };
//# sourceMappingURL=Download.js.map
